/**
 * L'Invoice project translations - Modals section
 */

const modals = {
  // Delete confirmations
  deleteBank: "Delete bank?",
  deleteBankDescription: "Are you sure you want to delete the bank",
  deleteItem: "Delete item",
  deleteItemDescription: "Are you sure you want to delete this line?",
  deleteCustomerTitle: "Delete customer",
  deleteCustomerText: "Are you sure you want to delete the customer \"{{customerName}}\"? This action cannot be undone.",
  // Actions
  confirm: "Confirm",
  cancel: "Cancel",
  // Preview step errors
  requestError: "Request error",
  invoiceNotFound: "Invoice not found",
  invoiceNotFoundDescription: "Cannot save invoice because invoice ID is not available.",
  invoiceSaveFailed: "Invoice save failed",
  invoiceSaveFailedDescription: "Something went wrong while saving invoice.",
  invoiceLoadFailed: "Invoice load failed",
  invoiceLoadFailedDescription: "Something went wrong while loading invoice.",
  invoiceNotLoaded: "Invoice not loaded",
  invoiceNotLoadedDescription: "Cannot open edit page because invoice data was not loaded.",
  // Bank modal
  addBankingInfo: "Add banking info",
  editBankingInfo: "Edit {{bankName}}",
  // Delete invoice modal
  deleteInvoiceTitle: "Delete invoice #{{invoiceNumber}}?",
  deleteInvoiceText: "This invoice will be permanently deleted. Are you sure?",
  deleteDraftInvoiceTitle: "Delete draft invoice #{{invoiceNumber}}?",
  deleteDraftInvoiceText: "Are you sure you want to delete this draft invoice?",
  deleteVoidedInvoiceTitle: "Delete voided invoice #{{invoiceNumber}}?",
  deleteVoidedInvoiceText: "This voided invoice will be permanently deleted. Are you sure?",
  deleteInvoiceDefaultTitle: "Delete invoice?",
  deleteInvoiceDefaultText: "Are you sure you want to delete this invoice?",
  // Warning/eligibility modal
  invoicesCannotBeConvertedTitle: "Some invoices can't be converted",
  invoicesCannotBeConvertedText: "These invoices can't be converted to e-documents because the customer's sending method is set to <b>Email</b>.",
  notEligible: "Not eligible:",
  changeSendingMethodHint: "To convert them, change the sending method in the customer settings.",
  continueConvertingRemaining: "Continue converting the remaining {{count}} invoice(s)?",
  nothingToConvert: "Nothing to convert",
  // E-Documents — send confirmation (neutral wording for all networks)
  confirmSendEdocTitle: "Confirm sending",
  confirmSendEdocDescription: "Are you sure you want to send the selected invoices?",
  confirmSendEdocWithEmailDescription:
    "Are you sure you want to send the selected invoices with email?",
  confirmSendEdocHighlightSingular: "{{count}} invoice will be sent",
  confirmSendEdocHighlightPlural: "{{count}} invoices will be sent",
  moveToDocumentsConfirmTitle: "Move to Documents?",
  moveToDocumentsConfirmDescription:
    "These e-documents will be removed from E-Documents and returned to Documents so you can edit them again.",
  moveToDocumentsHighlightSingular: "{{count}} e-document will be moved",
  moveToDocumentsHighlightPlural: "{{count}} e-documents will be moved",
  moveToDocumentsPartialTitle: "Some selected e-documents can't be moved",
  moveToDocumentsPartialIntro:
    "Only e-documents with status New or Error can be moved back to Documents. Other statuses will be skipped.",
  moveToDocumentsNotEligible: "Not eligible:",
  moveToDocumentsContinueHint:
    "Continue and move {{count}} eligible e-document(s) back to Documents?",
  moveToDocumentsNothingEligible: "Nothing to move",
  moveToDocumentsNoneEligibleTitle: "No eligible e-documents",
  moveToDocumentsNoneEligibleBody:
    "None of the selected e-documents have status New or Error, so nothing can be moved to Documents.",
  moveToDocumentsAllPagesTitle: "Move to Documents unavailable",
  moveToDocumentsAllPagesBody:
    "This action works with documents selected on the current page. Clear the “all pages” selection and select e-documents on this page, then try again.",
  moveToDocumentsRequestFailed: "Could not move e-documents. Please try again.",
};

export default modals;
